import React, { useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

/** Écran bloquant : un compte BP créé par l'admin doit remplacer son mot de passe temporaire. */
export const BpPasswordGate = ({ onDone, embedded = false }) => {
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("8 caractères minimum"); return; }
    if (pw !== pw2) { toast.error("Les deux mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: pw });
      toast.success("Mot de passe mis à jour");
      setCurrent(""); setPw(""); setPw2("");
      onDone?.();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className={embedded ? "" : "p-6 lg:p-10 max-w-xl"} data-testid="bp-password-gate">
      {!embedded && (
        <div className="mb-6">
          <div className="text-xs uppercase tracking-[0.3em] text-[#868E96] font-bold mb-2">// Sécurité</div>
          <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter">Choisissez votre mot de passe.</h1>
          <p className="text-sm text-[#495057] mt-2">Vous utilisez un mot de passe temporaire envoyé par l'équipe PAG. Remplacez-le pour accéder à votre espace.</p>
        </div>
      )}
      <form onSubmit={submit} className="bg-white border border-[#DEE2E6] p-5 space-y-3">
        <div className="space-y-1.5"><Label className="text-[10px] uppercase tracking-[0.2em] font-semibold">{embedded ? "Mot de passe actuel" : "Mot de passe temporaire"}</Label><Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="bp-pw-current" /></div>
        <div className="space-y-1.5"><Label className="text-[10px] uppercase tracking-[0.2em] font-semibold">Nouveau mot de passe (8+ caractères)</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} data-testid="bp-pw-new" /></div>
        <div className="space-y-1.5"><Label className="text-[10px] uppercase tracking-[0.2em] font-semibold">Confirmation</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="bp-pw-confirm" /></div>
        <Button type="submit" disabled={busy} className="bg-[#0A0A0A] text-white" data-testid="bp-pw-submit"><KeyRound className="h-4 w-4 mr-2" />{busy ? "Enregistrement…" : "Enregistrer le mot de passe"}</Button>
      </form>
    </div>
  );
};
